import React from 'react';
import { AND, COND, OP, OR, SEPARATOR } from "../../misc/RuleObjectTypes";
import { useContext, useEffect, useState } from "react";
import SubCondition from "./SubCondition";
import { RulesContext } from "../../RulesContext";
import Button from 'Components/DesignSystem/Button/Button';
import { Add } from 'Components/DesignSystem/Iconography/Icons';

const NestedCondition = ({ element, rootPosition }) => {
  const { ruleDispatch } = useContext(RulesContext);
  function groupConditions(arr, rootPosition) {
    let renderArr = arr.map((element, index) => {
      if (Array.isArray(element)) {
        return groupConditions(element, `${rootPosition}${SEPARATOR}${index}`);
      }
      switch (element.type) {
        case OP:
          return (
            <SubConditionOperator
              key={index}
              {...{
                element,
                position: element.position,
              }}
            />
          );
        case COND:
          return (
            <SubCondition
              key={index}
              {...{
                element,
                position: element.position,
              }}
            />
          );
        default:
          return null;
      }
    });
    return (
      <div className="condition-wrapper ms-0" key={rootPosition}>
        <div className="left-nesting-bracket" />
        <div>
          {renderArr.map((element) => {
            return element;
          })}
        </div>
        <div className="right-nesting-bracket" />
      </div>
    );
  }
  return (
    <div className="tw-border tw-border-edge tw-rounded-md tw-bg-surface-sunken">
      <div className="">
        {groupConditions(element, rootPosition)}
        {/* DS Button — Condition.js's twin (okf/rules § 4.5). */}
        <Button
          variant="tertiary"
          size="sm"
          icon={<Add size={16} aria-hidden="true" />}
          iconSize="small"
          className="tw-mx-3"
          data-testid="rule-add-condition-btn"
          onClick={() =>
            ruleDispatch({
              type: "ADD_SUBCONDITION",
              position: rootPosition,
            })
          }
        >
          Add Condition
        </Button>
        {/* <button
          className="mt-1 mb-2 add-logic-filter-button ms-4"
          style={{ fontSize: "0.8rem" }}
          onClick={() =>
            ruleDispatch({
              type: "ADD_SUBCONDITION",
              position: rootPosition,
            })
          }
        >
          ADD LOGIC
        </button> */}
      </div>
      <div className="separator" />
    </div>
  );
};
export default NestedCondition;

const SubConditionOperator = ({ element, position }) => {
  const { ruleDispatch } = useContext(RulesContext);
  const [subConditionOp, setSubConditionOp] = useState(AND);
  useEffect(() => {
    setSubConditionOp(element.subConditionOp);
  });

  return (
    <div className="sub-condition-operator">
      <select data-testid="rulebuilder-nestedcondition-select-1"
        className='form-select drop-down-dm tw-w-[7%] shadow-none tw-border tw-border-edge tw-bg-surface tw-rounded tw-font-medium tw-text-sm tw-text-ink-tertiary tw-px-2 tw-py-1'
        value={subConditionOp}
        onChange={(el) =>
          ruleDispatch({
            type: "SET_COND_OP",
            subConditionOp: el.target.value,
            position: position,
          })
        }
      >
        <option value={AND}>And</option>
        <option value={OR}>Or</option>
      </select>
    </div>
  );
};
